import {Drawer} from "antd";
import {DEFAULT_STATE, PaxNotifierDrawerReducer} from "./state";
import React, {PropsWithChildren} from "react";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export function usePaxNotifierDrawerState(){
    const [state, dispatch] = React.useReducer(PaxNotifierDrawerReducer, DEFAULT_STATE);

    return {
        isOpen: state.isOpen,
        close: () => dispatch({ type: 'CLOSE_DRAWER' }),
        open: () => dispatch({ type: 'OPEN_DRAWER' })
    }
}

export type PaxNotifierDrawerContextType = ReturnType<typeof usePaxNotifierDrawerState>;

export const PaxNotifierDrawerContext = React.createContext<PaxNotifierDrawerContextType>(null);

export type PaxNotifierDrawerProps = PropsWithChildren<PaxNotifierDrawerContextType>;

export default function PaxNotifierDrawer(props: PaxNotifierDrawerProps) {

    const bp = useBreakpoints();

    const width = bp.max('medium') ? '100%' : 600;

    return (
        <Drawer
            title="Pax Notifier"
            placement="right"
            width={width}
            onClose={() => props.close()}
            visible={props.isOpen}
        >
            <PaxNotifierDrawerContext.Provider value={props}>
                {props.children}
            </PaxNotifierDrawerContext.Provider>
        </Drawer>
    )
}